export interface AiStreamResult {
  status: number
  payload: unknown
  retry_after?: string
}

/** Heartbeats are SSE comments; only a complete terminal event is a response. */
export function parseAiStream(text: string): AiStreamResult {
  for (const event of text.replace(/\r\n/g, '\n').split('\n\n').slice(0, -1)) {
    if (!event.split('\n').includes('event: result')) continue
    const data = event.split('\n').filter(line => line.startsWith('data:')).map(line => line.slice(5).trimStart()).join('\n')
    const result = JSON.parse(data) as Partial<AiStreamResult>
    if (typeof result.status === 'number' && result.status >= 200 && result.status <= 599 && result.payload && typeof result.payload === 'object') {
      return result as AiStreamResult
    }
  }
  throw new Error('Incomplete AI stream')
}
